<template>
  <div class="hello">
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>杰博员工人数统计</el-breadcrumb-item>
          <el-breadcrumb-item>月报</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="monthlyReportTable">
        <el-table
          :data="tableData"
          style="width: 99%"
          stripe
          @cell-click="handdle"
          show-summary
          :cell-style="columnStyle"
        >
          <el-table-column align="center" type="selection" width="70px"></el-table-column>
          <el-table-column align="center" label="服务中心000" prop="serviceCentre" min-width="12%"></el-table-column>
          <el-table-column align="center" sortable label="客户数量" prop="customerNum" min-width="15%"></el-table-column>
          <el-table-column
            align="center"
            sortable
            label="月初在职人数"
            prop="beginMonthNumEmployees"
            min-width="15%"
          ></el-table-column>
          <el-table-column
            align="center"
            sortable
            label="当月入职人数"
            prop="monthEmploymentNum"
            min-width="15%"
          ></el-table-column>
          <el-table-column
            align="center"
            sortable
            label="当月离职人数"
            prop="monthQuitNum"
            min-width="15%"
          ></el-table-column>
          <el-table-column
            align="center"
            sortable
            label="月末在职人数"
            prop="endMonthNumEmployees"
            min-width="15%"
          ></el-table-column>
          <el-table-column align="center" sortable label="离职率" prop="quitRete" min-width="9%"></el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="100"
            layout="total,prev, pager, next, jumper"
            :total="1000"
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-drawer :visible.sync="drawer1" :with-header="false" :modal="false" size="960px">
      <div class="titleAndButton">
        <div class="monthlyTitle">宁波公司员工人数统计&nbsp;|&nbsp;月报</div>
        <div>
          <button class="exportButton" style="margin-right:10px">导出</button>
          <button class="clear" @click="close" style="margin-right:5px">关闭</button>
        </div>
      </div>
      <div>
        <div class="monthlyReportTable">
          <el-table :data="tableData3" style="width: 99%" stripe show-summary>
            <el-table-column align="center" label="项目名称" prop="customerName" min-width="8"></el-table-column>
            <el-table-column align="center" label="项目类别" prop="projectType" min-width="8%"></el-table-column>
            <el-table-column
              align="center"
              label="业务立项部门"
              prop="businessDepartment"
              min-width="11%"
            ></el-table-column>
            <el-table-column align="center" label="负责客服" prop="serve" min-width="9%"></el-table-column>
            <el-table-column
              align="center"
              sortable
              label="月初在职人数"
              prop="beginMonthNumEmployees"
              min-width="13%"
            ></el-table-column>
            <el-table-column
              align="center"
              sortable
              label="当月录用人数"
              prop="monthEmploymentNum"
              min-width="13%"
            ></el-table-column>
            <el-table-column
              align="center"
              sortable
              label="当月离职人数"
              prop="monthQuitNum"
              min-width="13%"
            ></el-table-column>
            <el-table-column
              align="center"
              sortable
              label="月末在职人数"
              prop="endMonthNumEmployees"
              min-width="13%"
            ></el-table-column>
            <el-table-column align="center" sortable label="离职率" prop="quitRete" min-width="10%"></el-table-column>
          </el-table>
          <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage3"
              :page-size="100"
              layout="total,prev, pager, next, jumper"
              :total="1000"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- <el-drawer :visible.sync="drawer2" :with-header="false" :modal="false" size="72%">
      <div class="titleAndButton">
        <div class="monthlyTitle">
         英博销售|当月入职人员花名册 
        </div>
        <div>
          <button class="exportButton" style="margin-right:10px">导出</button>
          <button class="clear" @click="close" style="margin-right:5px">关闭</button>
        </div>
      </div>
      <div>
        <div class="monthlyReportTable">
        <el-table :data="tableData5" style="width: 99%" stripe>
          <el-table-column align="center" label="项目名称" prop="projectName" min-width="16%"></el-table-column>
          <el-table-column align="center" label="员工姓名" prop="employeeName" min-width="16%"></el-table-column>
          <el-table-column align="center" label="身份证号码" prop="idCard" min-width="20%"></el-table-column>
          <el-table-column align="center" label="用工之日" prop="entryDate" min-width="16%"></el-table-column>
          <el-table-column align="center" label="离职日期" prop="quitDate" min-width="16%"></el-table-column>
          <el-table-column align="center" label="招聘渠道" prop="channel" min-width="16%"></el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="100"
            layout="total,prev, pager, next, jumper"
            :total="1000"
          ></el-pagination>
        </div>
      </div>
      </div>
    </el-drawer>-->
  </div>
</template>

<script>
import FormTop from "./components/formTop";
export default {
  components: {
    FormTop
  },
  data() {
    return {
      drawer1: false,
      drawer2: false,
      currentPage3: 1,
      tableData: [
        {
          serviceCentre: "宁波公司",
          customerNum: 360,
          beginMonthNumEmployees: 180176,
          monthEmploymentNum: 3950,
          monthQuitNum: 650,
          endMonthNumEmployees: 20988,
          quitRete: "0.65%"
        },
        {
          serviceCentre: "杭州公司",
          customerNum: 340,
          beginMonthNumEmployees: 180266,
          monthEmploymentNum: 3840,
          monthQuitNum: 630,
          endMonthNumEmployees: 20868,
          quitRete: "0.80%"
        },
        {
          serviceCentre: "上海公司",
          customerNum: 350,
          beginMonthNumEmployees: 180166,
          monthEmploymentNum: 3940,
          monthQuitNum: 640,
          endMonthNumEmployees: 20968,
          quitRete: "0.58%"
        }
      ],
      tableData3: [
        {
          customerName: "银涛",
          projectType: "代理",
          businessDepartment: "南栋",
          serve: "樊可欣",
          beginMonthNumEmployees: 374,
          monthEmploymentNum: 74,
          monthQuitNum: 94,
          endMonthNumEmployees: 589,
          quitRete: "0.65%"
        },
        {
          customerName: "金涛",
          projectType: "代理",
          businessDepartment: "南栋",
          serve: "樊可欣",
          beginMonthNumEmployees: 384,
          monthEmploymentNum: 75,
          monthQuitNum: 96,
          endMonthNumEmployees: 559,
          quitRete: "0.66%"
        },
        {
          customerName: "铁涛",
          projectType: "代理",
          businessDepartment: "南栋",
          serve: "樊可欣",
          beginMonthNumEmployees: 334,
          monthEmploymentNum: 45,
          monthQuitNum: 36,
          endMonthNumEmployees: 559,
          quitRete: "0.67%"
        }
      ],
      tableData5: [
        {
          projectName: "英博销售",
          employeeName: "林立",
          idCard: 330225199812295103,
          entryDate: "2020-08-04",
          quitDate: "-",
          channel: "市内"
        },
        {
          projectName: "英博销售",
          employeeName: "林立",
          idCard: 330225199812295103,
          entryDate: "2020-08-04",
          quitDate: "-",
          channel: "市内"
        },
        {
          projectName: "英博销售",
          employeeName: "林立",
          idCard: 330225199812295103,
          entryDate: "2020-08-04",
          quitDate: "-",
          channel: "其他"
        }
      ]
    };
  },
  methods: {
    handleClick(row) {
      console.log(row);
    },
    handleSizeChange(val) {
      this.page = val;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handdle(row, event, column, cell) {
      console.log(row, event, column, cell);
      if (event.label == "客户数量") {
        this.drawer1 = true;
      }
      // else if(event.label=='当月入职人数'){
      //   this.drawer2 = true
      // }
    },
    close() {
      this.drawer1 = false;
      this.drawer2 = false;
    },
    columnStyle({ row, column, rowIndex, columnIndex }) {
      // console.log( column)
      if (column.label == "客户数量") {
        return "color:#F78500";
      }
      if (column.label == "离职率") {
        return "color:#FF4362";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
.el-table--enable-row-hover .el-table__body tr:hover {
  cursor: pointer;
}

.monthlyReportTable .el-table td {
  padding: 8px 0;
}
.monthlyReportTable .el-table th {
  padding: 6px 0;
}
</style>